import { render, staticRenderFns } from "./aboutYj.vue?vue&type=template&id=37b62870&scoped=true"
import script from "./aboutYj.vue?vue&type=script&lang=js"
export * from "./aboutYj.vue?vue&type=script&lang=js"
import style0 from "./aboutYj.vue?vue&type=style&index=0&id=37b62870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b62870",
  null
  
)

export default component.exports